import {
  AddMeetingSuggestionDocument,
  ScreenProfile,
} from '@/graphql/generated-types';
import { apolloClient } from '@/utils/apollo';
import SentryGraphQLError from '@/utils/exceptions/SentryGraphQLError';

const addSuggestion = async ({
  profile,
  meetingId,
  suggestion,
}: {
  profile: ScreenProfile;
  meetingId: string;
  suggestion: string;
}) => {
  const response = await apolloClient.mutate({
    mutation: AddMeetingSuggestionDocument,
    variables: {
      profile,
      meetingId,
      suggestion,
    },
    errorPolicy: 'all',
  });

  if (response.data?.meeting?.suggestScreen?.success) {
    return response.data;
  }

  throw new SentryGraphQLError(`api.meetings.addSuggestion`, response);
};

export default {
  addSuggestion,
};
